module.exports = __webpack_public_path__ + "img/IMG_2051-1200w.210361b1.jpg";